// extracted by mini-css-extract-plugin
module.exports = {"layout":"layout-wrapper_layout__h9t_Z"};